<section class="add-watch-orders-dialog">
  <div mat-dialog-title class="dialog-header">
    <span class="title">Add Watch Order</span>
    <button
      mat-icon-button
      mat-dialog-close
      class="material-icons floatRight close-btn"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <app-add-watch-order
    [orders$]="this.orders$"
    [showHeader]="false"
  ></app-add-watch-order>
  <div class="dialog-footer">
    <div class="hidden"></div>
    <button
      id="addOrdersActionBtn"
      mat-flat-button
      color="primary"
      (click)="onAddWatchOrders()"
    >
      <span>Add Watch Orders</span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</section>
